import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Portal from '@material-ui/core/Portal';
import QTip from 'components/QuickenControls/QTip';
import QIconButton from 'components/QIconButton';
import BalanceSelectMenu from 'components/BalanceSelectMenu';
import AddIcon from '@material-ui/icons/Add';
import RefreshButton from 'containers/App/Header/RefreshButton';
import QButton from 'components/QButton';
import { useTheme } from '@material-ui/core/styles';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { isAcme, isQuicken } from 'isAcme';

export const AccountDrawerToggle = (props) => {

  const {classes, handleDrawerToggle, open, anchorEl} = props;

  const [isQTipOpen, setIsQTipOpen] = useState(true);

  const DrawerControlIcon = open ? ChevronLeftIcon : ChevronRightIcon;

  // Once the value of open changes, we know it is safe to show QTips again without the 'render forever' ToolTip bug!
  useEffect(() => {
    setIsQTipOpen(true);
  }, [open]);

  // This guarantees there is no race condition and setQTipOpen is always set to false first!
  const toggleQTip = (e, callback) => {
    setIsQTipOpen(false);
    callback(e);
  }

  return (
    <Portal
      container={anchorEl}
    >
      <div
        className={classNames(classes.drawerOpenControl, open ? 'open': '')}
      >
        {/* This was to fix a bug where the QTip remained onscreen forever if it was rendered during the AccountDrawer opening/closing */}
        {isQTipOpen ?
          (<QTip
            title={`${!open ? 'Open' : 'Close'} the account bar`}
            placement="right"
            wrapId="account-drawer"
          >
            <QIconButton
              size="small-no-padding"
              aria-label="Close the account bar"
              onClick={(e) => {
                toggleQTip(e, handleDrawerToggle)
              }}
              id="account-drawer-toggle"
              style={{ height: 24, width: 24 }}
            >
              <DrawerControlIcon className={classes.drawerIcons}/>
            </QIconButton>
          </QTip>)
          :
          (<QIconButton
            size="small-no-padding"
            aria-label="Close the account bar"
            onClick={(e) => {
              toggleQTip(e, handleDrawerToggle)
            }}
            id="account-drawer-toggle"
            style={{ height: 24, width: 24 }}
          >
            <DrawerControlIcon className={classes.drawerIcons}/>
          </QIconButton>)}

      </div>
    </Portal>
  )
};

AccountDrawerToggle.propTypes = {
  classes: PropTypes.object,
  handleDrawerToggle: PropTypes.func,
  open: PropTypes.bool,
  anchorEl: PropTypes.object,
};

export const AccountListHeader = (props) => {
  const theme = useTheme();
  const label = theme.components.accountDrawer.addFiLabel;
  const size = theme.components.accountDrawer.actionButtonSize;

  const {classes, doAccountDiscovery, handleAddInstitutionLogin} = props;

  return (
    <>
      <Typography className={classes.drawerListTitle} variant="h5">
        Accounts
      </Typography>

      {isQuicken &&
        <RefreshButton
          isInAccountBar
          id="sync-arrow"
          classes={{buttonRoot: classes.drawerHeaderIcons}}
        />
      }

      {doAccountDiscovery &&
        <QTip
          title="Add your account"
          placement="right"
        >
          <QButton
            id="addFiButton"
            aria-label="Add Institution Login"
            onClick={handleAddInstitutionLogin}
            style={{ minWidth: 0, backgroundColor: 'transparent', height: !label && size, width: !label && size, marginRight: label && -16 }}
            variant={label ? 'text' : 'containedIcon' }
          >
            <AddIcon className={!label ? classNames(classes.drawerHeaderIcons, isAcme ? classes.roundedButton: '') : ''}/>
            {label && <span style={{ marginTop: 2 }}>{label}</span>}
          </QButton>
        </QTip>
      }
      {isQuicken &&
        <BalanceSelectMenu
          classes={{balanceMenu: classes.balanceMenu, iconColor: classes.drawerHeaderIcons}}
          menuIconButtonSize="small"
        />
      }
    </>
  )
};

AccountListHeader.propTypes = {
  classes: PropTypes.object,
  handleAddInstitutionLogin: PropTypes.func,
  doAccountDiscovery: PropTypes.func,
};
